import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Input, Modal, Loading } from '../components/all';
import useUserStore from '../store/useUserStore';
import useGeneric from '../hooks/useGeneric';
import toast from '../utils/toast';

export default function Perfil() {
    const { usuario } = useUserStore();
    const { AlterarSenha } = useGeneric();

    const [currentPassword, setCurrentPassword] = useState('');
    const [modalMessage, setModalMessage] = useState('');
    const [isModalVisible, setModalVisible] = useState(false);
    const [isChangePasswordModalVisible, setChangePasswordModalVisible] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [nivelDaSenha, setNivelDaSenha] = useState('Ruim.');
    const [nivelProgressBar, setnivelProgressBar] = useState(0);
    const navigate = useNavigate();
    const [horasAntes, setHorasAntes] = useState('');


    const showToast = (type, text1, text2) => { 
        toast.show(type, `${text1}: ${text2}`);
    };

    const toggleModal = (message) => {
        setModalMessage(message);
        setModalVisible(!isModalVisible);
    };

    useEffect(() => {
        let horas = usuario.configuracoes.horasPraDesmarcarAulas;
        setHorasAntes(horas)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleChangePassword = async () => {
        if (newPassword.length < 6 || newPassword.length > 12) {
            showToast('error', 'Erro', 'A nova senha deve ter pelo menos 6 caracteres e no máximo 12.');
            return;
        }

        setLoading(true);
        try {
            const resultado = await AlterarSenha(usuario.usuario_id, currentPassword, newPassword);
            if (!resultado) {
                showToast('error', 'Erro', 'Senha atual incorreta');
                return;
            }
            showToast('success', 'Sucesso', 'Senha Alterada!');
            navigate('/')

        } catch (error) {
            showToast('error', 'Erro', `Erro ao alterar Senha: ${error}`);
        } finally {
            setLoading(false);
        }
    };

    function AlterandoSenhaEVerificando(str) {
        const temMaiuscula = /[A-Z]/.test(str);
        const temNumero = /\d/.test(str);
        const temSimbolo = /[^A-Za-z0-9]/.test(str);
        const tamanhoSuficiente = str.length >= 6;

        let nivel = "Ruim.";
        let progresso = 0;

        if (tamanhoSuficiente) {
            if (temMaiuscula && temNumero && temSimbolo) {
                nivel = "Perfeito!!";
                progresso = 100;
            } else if (temMaiuscula && temNumero) {
                nivel = "Ótimo!";
                progresso = 80;
            } else if (temMaiuscula) {
                nivel = "Bom.";
                progresso = 40;
            } else {
                nivel = "Aceitável.";
                progresso = 30;
            }
        }

        setNivelDaSenha(nivel);
        setnivelProgressBar(progresso);
        setNewPassword(str);
    }

    function getCorSenha(nivel) {
        switch (nivel) {
            case "Ruim.":
                return "red";
            case "Aceitável.":
                return "orange";
            case "Bom.":
                return "green";
            case "Ótimo!":
                return "blue";
            case "Perfeito!!":
                return "green";
            default:
                return "gray";
        }
    }

    //#endregion

    return (
        <div className='flex flex-col gap-2 p-3 min-h-screen min-h-[100dvh] items-center justify-start sm:justify-center pt-6 pb-24 overflow-y-auto'>
            <h1 className='text-2xl font-bold'>Olá, {usuario.nome}</h1>
            
            <Button
                onClick={() => setChangePasswordModalVisible(true)}
            >
                Alterar Senha
                <span className="material-icons">lock</span>
            </Button>

            <button
                className='txtTermo'
                onClick={() =>
                    toggleModal(
                        `Termos de Utilização\n\nO usuario é responsável por:\n- Marcar suas aulas no sistema.\n- Desmarcar as aulas com antecedência mínima de ${horasAntes} horas.\n- Comparecer no horário agendado. Ausências podem levar a penalidades.\n\nAo continuar utilizando o sistema, você aceita esses termos.`
                    )
                }
            >
                Termos de Utilização
            </button>
            
            <Modal isOpen={isChangePasswordModalVisible}>
                <div className="flex flex-col items-center justify-center gap-6 w-full h-full text-center px-6">
                    <h2 className="text-2xl font-bold text-zinc-800">Alterar Senha</h2>
                    
                    <p className="text-sm text-zinc-600">Lembrando, a senha deve ter no mínimo 6 e no máximo 12 caracteres!</p>
                    
                    <Input
                        placeholder="Senha Atual"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        typ={'password'}
                    />
                    
                    <Input
                        placeholder="Nova Senha"
                        value={newPassword}
                        onChange={(e) => AlterandoSenhaEVerificando(e.target.value)}
                        typ={'password'}
                    />
                    
                    <h3 style={{ color: getCorSenha(nivelDaSenha) }}>Nível da Senha: {nivelDaSenha}</h3>
                    <progress
                        className='progressBarPas'
                        value={nivelProgressBar}
                        max="100"
                    ></progress>

                    <div className="flex gap-4 w-full justify-center">
                        <Button
                            onClick={handleChangePassword}
                            disabled={loading}
                        >
                            {loading ? 'Alterando...' : 'Confirmar'}
                            <span className="material-icons">check</span>
                        </Button>
                        
                        <Button
                            back="#999"
                            cor="#FFF"
                            onClick={() => {
                                setChangePasswordModalVisible(false);
                                setCurrentPassword('');
                                setNewPassword('');
                                setNivelDaSenha('Ruim.');
                                setnivelProgressBar(0);
                            }}
                        >
                            Cancelar
                        </Button>
                    </div>
                </div>
            </Modal>
            
            <Loading visible={loading} />
            
            <Modal isOpen={isModalVisible}>
                <div className="flex flex-col items-center justify-center gap-6 w-full h-full text-center px-6">
                    <img
                        alt="imageModal"
                        src="img-terms.svg"
                        className="w-40 h-40 object-contain opacity-90"
                    />

                    <p className="text-sm text-zinc-600 leading-relaxed max-w-xs">
                        {modalMessage}
                    </p>

                    <Button
                        back="#4B003B"
                        cor="#FFF"
                        onClick={() => setModalVisible(false)}
                    >
                        Fechar
                    </Button>
                </div>
            </Modal>
            <ToastContainer position="top-center" />
        </div>
    );
}
